module.exports = __webpack_public_path__ + "img/cc_logos.452f6cee.png";